type ContactPublisherNoteProps = {
  email: string | null;
  translations?: Record<string, string>;
};

export function ContactPublisherNote({ email, translations }: ContactPublisherNoteProps) {
  const label = translations?.['group_subscriptions.card.contact_publisher'] ?? 'Contact your publisher';

  if (!email) return <span className="font-medium text-gray-500">{label}</span>;

  return (
    <span className="text-gray-500">
      {label} - <span className="font-medium text-gray-700">{email}</span>
    </span>
  );
}
